<h1 style="font-size: 40px;">404</h1>
<h3 style="font-size: 30px;">{{ "error.pageNotFound.notFound" | translate}}</h3>

